import { useState } from 'react'

import { NICHT_VORHANDEN, api, ohne404 } from '../api'
import { useAktion, useLaden } from '../hooks'
import { TAKTE } from '../typen'
import type { Takt, TaktEinstellung } from '../typen'
import Meldungen from './Meldungen'

/** Der Titel eines Takts in Worten - unsere Beschriftung, sonst die des Backends, sonst der Wert. */
export function taktTitel(wert: string, einstellung?: TaktEinstellung | null): string {
  return TAKTE.find((t) => t.wert === wert)?.titel ?? einstellung?.moeglich[wert] ?? wert
}

/**
 * Der Takt für alle (Runde 4, 02.11.2026, `GET/PUT /api/disposition/takt`): welchen Stichtag und Horizont
 * Dispositionsblatt, Export, Heute, Fällig-Liste und Assistent nehmen, wenn niemand einen nennt. Frau Barth:
 * „Bestand dienstags (nach der Produktion und evtl. Lieferungen); geplante Produktion und Lieferungen bis
 * Freitag der darauffolgenden Woche“ - das ist der Standard „dienstag_freitag“.
 *
 * Getrennt von der Auswahl auf dem Dispositionsblatt: die gilt nur für die eigene Ansicht in diesem Browser-Tab.
 */
export default function TaktStandard() {
  const [auswahl, setAuswahl] = useState<Takt | null>(null)
  const { fehler, erfolg, arbeitet, setErfolg, ausfuehren } = useAktion()
  const { daten, fehler: ladeFehler, setDaten } = useLaden(() => ohne404(api.taktStandard()), [])

  if (daten === NICHT_VORHANDEN) return <p className="hinweis">Diese Einstellung kennt das Backend noch nicht.</p>
  const wert = auswahl ?? daten?.takt ?? ''

  function speichern() {
    if (!auswahl) return
    void ausfuehren(async () => {
      const neu = await api.taktStandardSetzen(auswahl)
      setDaten(neu)
      setAuswahl(null)
      setErfolg(`Gerechnet wird jetzt im Takt: ${taktTitel(neu.takt, neu)}.`)
    })
  }

  return (
    <div className="karte">
      <Meldungen fehler={ladeFehler ?? fehler} erfolg={erfolg} />
      <div className="leiste">
        <label className="feld">
          <span className="hinweis">Takt für alle</span>
          <select value={wert} disabled={!daten} onChange={(e) => setAuswahl(e.target.value as Takt)}>
            {TAKTE.map((t) => (
              <option key={t.wert} value={t.wert}>
                {t.titel}
                {daten && t.wert === daten.standard ? ' (Vorgabe)' : ''}
              </option>
            ))}
          </select>
        </label>
        <button className="haupt" disabled={arbeitet || !auswahl || auswahl === daten?.takt} onClick={speichern}>
          Speichern
        </button>
      </div>
      {daten && (
        <p className="hinweis" style={{ marginBottom: 0 }}>
          Ohne eigene Angabe zeigt ein Blatt heute: Stichtag {new Date(daten.stichtag).toLocaleDateString('de-DE')},
          Horizont bis {new Date(daten.horizont_bis).toLocaleDateString('de-DE')}. Gilt für Dispositionsblatt,
          Excel-Export, Heute, Fällig-Liste und Assistent; die Auswahl auf dem Dispositionsblatt selbst gilt nur
          für die eigene Ansicht.
        </p>
      )}
    </div>
  )
}
